var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('picture',[_c('img',{attrs:{"src":`/logos/logo${_vm.capitalizeFirstLetterOnly(_vm.$config.satelliteName)}.png`,"alt":_vm.$t('images.logo'),"width":"263","height":"auto"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }